import moment from 'moment';

const getDatePeriodFromNow = (comparativeDate) => {
  if (!comparativeDate) return null;
  const now = moment();
  const measurements = [
    {
      key: 'days',
      label: 'measurements.dayAgo',
    },
    {
      key: 'hours',
      label: 'measurements.hourAgo',
    },
    {
      key: 'minutes',
      label: 'measurements.minuteAgo',
    },
    {
      key: 'seconds',
      label: 'measurements.secondAgo',
    },
  ];
  let difference;
  let index;
  measurements.some((item, i) => {
    difference = now.diff(moment(comparativeDate), item.key);
    index = i;
    return difference !== 0;
  });

  return t(measurements[index].label, { ns: i18next.Namespace.COMMON, count: difference });
};

export default getDatePeriodFromNow;
